import { FILTER_TYPES, sortBy } from '@common/Filters/constants/filterTypes';

export const getFiltersForView = (translate, filters, hasOrderFilter) => {
    const filtersForView = filters.map(({ title, 'data-type': type }) => ({
        title,
        type
    }));

    if (hasOrderFilter) {
        filtersForView.push({
            type: sortBy,
            title: translate('listing.filter.sort_by.label')
        });
    }

    return filtersForView;
};

export const isCurrentActiveFilter = (activeFilter, newFilterType) => activeFilter && activeFilter.type === newFilterType;

export const isGenderOrAgeFilter = filterType => [FILTER_TYPES.gender, FILTER_TYPES.age].includes(filterType);
